import styled from 'styled-components';
import { ListboxMixin } from '../../mixins/components/ListboxMixin';
export var StyledListbox = /*#__PURE__*/styled.ul.withConfig({
  displayName: "StyledListbox",
  componentId: "c11n-8-107-0__sc-xd2iit-0"
})(["", ""], ListboxMixin);